// extracted by mini-css-extract-plugin
export default {"root":"nkBIs","loginHeader":"qfmu9","isBackButtonHidden":"y5jO8","close":"lsibr","back":"iWZUZ"};